import { getCookie } from "./localStorage";

let initialAuth = {
  isAuthenticated: false,
  isAuthLoading: false,
  isNoAccess: false,
  userData: getCookie("userData") || null,
};

const initialAdmin = {
  regions: [],
  selectedRegion: null,
  isRegionLoading: false,
  isRegionSaved: false,

  nationals: [],
  selectedNational: null,
  isNationalLoading: false,
  isNationalSaved: false,

  worklist: [],
  isWorklistLoading: false,
  worklistDropdown: [],
  selectedWorklist: null,
  region: [],
  rpce: [],
  rpceDropdown: [],
  regionalPracticeWorklistDropdown: [],
  regionalPractice: [],
  worklistCategoryDropdown: [],

  isWorkListLoading: false,
  workListDropdown: [],
  selectedWorkList: null,

  worklistDefinition: [],
  worklistDefinitionTypeDropdown: [],
  worklistDefinitionFacilityDropdown: [],
  isWorklistDefinitionSaved: false,
  worklistDefinitionSaveError: null,
  isWorklistDefinitionLoading: false,

  worklistGroup: [],
  worklistGroupWorklistDropdown: [],
  isWorklistGroupSaved: false,
  worklistGroupSaveError: null,
  isWorklistGroupLoading: false,

  worklistDefinitionConfiguration: [],
  worklistDefinitionConfigurationDropdowns: {
    siteDropdownItems: [],
    priorityBucketDropdownItems: [],
    subSpecialityDropdownItems: [],
    facilityTagDropdownItems: [],
  },
  selectedWorklistDefinitionConfiguration: null,
  isWorklistDefinitionConfigurationSaved: false,
  worklistDefinitionConfigurationSaveError: null,
  isWorklistDefinitionConfigurationLoading: false,

  tagCategoryConfiguration: [],
  selectedTagCategoryConfiguration: null,
  isTagCategoryConfigurationSaved: false,
  tagCategoryConfigurationSaveError: null,
  isTagCategoryConfigurationLoading: false,

  manageTagsShell: null,
  isManageTagsLoading: false,
  isManageTagsSaved: false,
  manageTagsSaveError: null,

  assignmentEntities: null,
  assignmentRequestKey: null,
  isAssignmentsLoading: false,

  tagSaveResult: null,
  isTagSaved: false,
  tagSaveError: null,

  isTagDeleted: false,
  tagDeleteError: null,

  RPCE: [],
  selectedRPCE: null,
  exportRPCE: null,
  isRPCELoading: false,

  subpractices: [],
  selectedSubpractice: null,
  isSubpracticeLoading: false,
  subpracticeDropdown: [],

  practices: [],
  selectedPractice: null,
  regionDropdown: [],
  radTypeDropdown: [],
  exportPractice: null,
  isPracticeLoading: false,

  sectionWorklist: [],
  selectedsectionWorklist: null,
  isSectionWorklistLoading: false,
  sectionWorklistDropdown: [],

  userManagement: [],
  selectedUserManagement: null,
  isUserManagementLoading: false,

  userManagementRole: [],
  userManagementDesignation: [],
  selectedUser: null,
  tenantDropdown: [],
  userRegionalPracticeDropdown: [],
  userMainPracticeDropdown: [],

  RequestStatus: [],
  selectedRequestStatus: null,
  isRequestStatusLoading: false,

  holidayPlanner: [],
  selectedHolidayPlanner: null,
  isHolidayPlannerLoading: false,
  holidayPlannerDropdown: [],

  HolidayDemandPlanner: [],
  selectedHolidayDemandPlanner: null,
  isHolidayDemandPlannerLoading: false,
  holidayDemandPlannerSaveResponse: null,

  //------Main Practice States------//
  MainPractice: [],
  isMainPracticeLoading: false,

  isMaindropdownloading: false,
  DropdownDDList: {},
  selectedMainPractice: [],

  //------Regional Practice Worklist Start ------//
  regionalPracticeWorklist: [],
  selectedRegionalPracticeWorklist: null,
  isRegionalPracticeWorklistLoading: false,
  regionalPracticeDropdown: [],

  //------Regional Practice Worklist End ------//

  //------Regional Practice Start ------//
  RegionalPractice: [],
  isRegionalPracticeLoading: false,
  selectedRegionalPractice: null,
  //------Regional Practice End ------//

  // Admin dropdowns for forms
  adminDropdowns: {
    selectedUser: null,
    roles: [
      { RoleID: 1, RoleName: "Admin" },
      { RoleID: 2, RoleName: "Manager" },
      { RoleID: 3, RoleName: "User" },
      { RoleID: 4, RoleName: "Stakeholder" },
      { RoleID: 5, RoleName: "Local Practice Director" },
    ],
    designations: [
      { DesignationID: 1, DesignationName: "Senior Manager" },
      { DesignationID: 2, DesignationName: "Manager" },
      { DesignationID: 3, DesignationName: "Senior Associate" },
      { DesignationID: 4, DesignationName: "Associate" },
      { DesignationID: 5, DesignationName: "Analyst" },
      { DesignationID: 6, DesignationName: "Senior Analyst" },
    ],
  },

  isRegionDropdownLoading: false,
  regionDropdownList: [],

  isNationalDropdownLoading: false,
  nationalDropdownList: [],
};

const initialCommon = {
  isExporting: false,
  lastExportRequestId: null,
  lastExportStatus: null,
  lastExportCompletedAt: null,
  dashboardDetails: [],
  providerRequestDailyCounts: [],
  providerRequestTodayDate: null,
  isLoadingProviderRequestDaily: false,
  isLoadingDashboard: false,
  allowedMenus: [],
  assignedSitesCount: 0,
  unassignedSitesCount: 0,
  assignedRolesWithPractices: [],
  dynamicTimezone: 'CT',
  defaultWorklists: { items: [], isProvider: false, userId: null, isLoaded: false, isLoading: false },
};

const initialDropdownMgmt = {
  radTypes: [],
  selectedRadType: null,
  isRadTypeLoading: false,

  radStatus: [],
  selectedRadStatus: null,
  isRadStatusLoading: false,

  subspecialities: [],
  selectedSubspeciality: null,
  isSubspecialityLoading: false,

  billingManagement: [],
  selectedBillingManagement: null,
  isBillingManagementLoading: false,

  weekRotations: [],
  selectedWeekRotation: null,
  isWeekRotationLoading: false,

  weekRotationTemplates: [],
  selectedWeekRotationTemplate: null,
  isWeekRotationTemplateLoading: false,

  partnershipRates: [],
  selectedPartnershipRate: null,
  isPartnershipRateLoading: false,

  partnershipStatuses: [],
  selectedPartnershipStatus: null,
  isPartnershipStatusLoading: false,

  partnershipTimes: [],
  selectedPartnershipTime: null,
  isPartnershipTimeLoading: false,

  isRadCommunicationTypeLoading: false,
  radCommunicationTypes: [],
  selectedRadCommunicationType: null,

  RVURATE: [],
  selectedRVURATE: null,
  isRVURATELoading: false,

  TraumaFacilityLevel: [],
  selectedTraumaFacilityLevel: null,
  isTraumaFacilityLevelLoading: false,

  isLoadingDropdowns: false,

  isQgendaSectionLoading: false,
  qgendaSections: [],
  selectedQgendaSection: null,

  committees: [],
  selectedCommittees: null,
  isCommitteesLoading: false,

  futureSectionChange: [],
  selectedFutureSectionChange: null,
  isFutureSectionChangeLoading: false,

  modality: [],
  selectedModality: null,
  isModalityLoading: false,

  priority: [],
  selectedPriority: null,
  isPriorityLoading: false,
  priorityBuckets: [],
  isPriorityBucketLoading: false,

  staffCategories: [],
  selectedStaffCategory: null,
  isStaffCategoryLoading: false,

  staffingAgency: [],
  selectedStaffingAgency: null,
  isStaffingAgencyLoading: false,
};

const initialConfiguration = {
  SiteCoverageMatrix: [],
  SiteCoverageDetailByID: null,
  isSiteCoverageLoading: false,
  isSiteCoverageDetailByIdLoading: false,

  isSiteStatusLoading: false,
  siteStatuses: [],
  selectedSiteStatus: null,

  isCoverageGapLoading: false,
  coverageGaps: [],
  selectedCoverageGap: null,

  // DLS Configuration states - start
  dlsConfigurations: [],
  sitesWithoutDLS: [],
  isDLSConfigurationLoading: false,
  isSitesWithoutDLSLoading: false,
  isDLSSaveLoading: false,
  // DLS Configuration states - end

  isBlockPlanningLoading: false,
  blockPlannings: [],
  selectedBlockPlanning: null,

  // Day of Week Configuration states - start
  dayOfWeekConfigurations: [],
  weekDayList: [],
  weekEndList: [],
  isDayOfWeekConfigurationLoading: false,
  // Day of Week Configuration states - end

  //Simulation Configuration states - start
  simulations: [],
  isSimulationLoading: false,
  selectedSimulation: null,
  //Simulation Configuration states - end

  //Email Configuration states - start
  emailConfigurations: [],
  isEmailConfigurationLoading: false,
  lastSavedEmailConfiguration: null,
  lastSavedEmailConfigurationError: null,
  //Email Configuration states - end

  isLoadingDropdowns: false,
  isPriorityLoading: false,
  priorityDropdown: [],
  prioritySLAMappings: [],
  selectedPrioritySLAMapping: null,
  isPrioritySLAMappingLoading: false,
  prioritySLABuckets: [],
  isPrioritySLABucketsLoading: false,

  stateLicenseMappings: [],
  stateLicenseMappingDropdown: [],
  isStateLicenseMappingLoading: false,
  isStateLicenseMappingSaving: false,
  stateLicenseMappingError: null,

  privilegesMappings: [],
  privilegesMappingDropdown: [],
  isPrivilegesMappingLoading: false,
  isPrivilegesMappingSaving: false,
  privilegesMappingError: null,

  readingStatusMappings: [],
  readingStatusMappingDropdown: [],
  isReadingStatusMappingLoading: false,
  isReadingStatusMappingSaving: false,
  readingStatusMappingError: null,
  defineMismatchList: [],
  defineMismatchDropdowns: {
    privilegeStatusList: [],
    readingStatusList: [],
    licenseStatusList: [],
  },
  isDefineMismatchLoading: false,
  isDefineMismatchSaving: false,
  defineMismatchError: null,

  TaskConfiguration: [],
  selectedTaskConfiguration: [],
  Worklist: null,
  WorkListDetailsList: [],
  TaskCategoryDetailsList: [],
  TaskTypeDetailsList: [],
  taskSaveInlineError: "",
  isTaskConfigurationLoading: false,
  isTaskSequenceSaving: false,
  taskSequenceLock: null,
  taskSequenceLockRequestId: null,
  isTaskSequenceLockAcquiring: false,
  isTaskSequenceLockReleasing: false,
  taskSequenceSaveStatus: false,
  taskTags: [],
  isTaskTagsLoading: false,
  isTaskTagsSaving: false,
  taskTagsError: null,

  providerTaskPoolHeader: null,
  providerTaskPoolProviders: [],
  providerTaskPoolProviderOptions: [],
  providerTaskPoolOccurrenceOptions: [],
  providerTaskPoolConflicts: [],
  providerTaskPoolLastSaved: null,
  isProviderTaskPoolLoading: false,
  isProviderTaskPoolSaving: false,
  isProviderTaskPoolProviderOptionsLoading: false,
  isProviderTaskPoolExporting: false,
  providerTaskPoolError: null,
};

const initialRad = {
  //Rad List
  radList: [],
  unassignedProviderListData: [],
  isUnassignedProviderListLoading: false,
  unassignedProviderListError: null,
  fieldName: [],
  fieldValues: [],
  isCustomView: false,
  isRadListLoading: false,
  stateLicenseList: [],
  isStateLicenseLoading: false,
  stateLicenseNotesList: [],
  isStateLicenseNotesLoading: false,
  isAddStateLicenseNoteLoading: false,
  isRadProfileLoading: false,
  isExporting: false,
  saveRadScheduleError: null,

  radProfileImageData: null,
  isRadProfileImageDownloading: false,
  isRadProfileImageDeleting: false,

  //Rad Capacity
  dropdownFilterData: [],
  capacityInputData: [],
  defaultRadCapacity: {},
  capacityInputDataNew: [],
  defaultRadCapacityNew: {},
  capacityFilterMasters: { ProviderList: [], ProviderTypes: [], WorkLocations: [] },
  updatedRadCapacityInputNew: {},
  radCapacityIpUploadResponseNew: {},

  // Edit Provider Profile states
  isEditRadProfileLoading: false,
  radiologistData: {},
  dropdownData: {},
  editRadProfileError: null,
  isSaveRadLoading: false,
  saveRadError: null,
  saveRadResult: null,
  zipCodeData: null,
  zipCodeAddressType: null,
  isZipCodeLoading: false,
  CityName: "",
  StateName: "",
  contractSummary: "",
  contractSummaryID: "",
  contractDocBase64Array: [],
  radAssignmentsDropdown: {},
  radAssignmentsDetails: {},
  isRadAssignmentsDropdownLoading: false,
  isRadAssignmentsDetailsLoading: false,
  isSaveRadAssignmentsLoading: false,
  isDeleteRadAssignmentLoading: false,
  saveRadAssignmentsResult: null,
  saveRadAssignmentsError: null,
  deleteRadAssignmentResult: null,
  deleteRadAssignmentError: null,
  radAssignmentsError: null,

  //Rad Profile
  siteDDList: [],
  priorityDDList: [],
  modalityDDList: [],
  radStatusDDList: [],
  siteStatusDDList: [],
  radMetricsData: {},
  isAssociatedSiteMetricsLoading: false,
  scheduleRequestList: [],
  isScheduleRequestLoading: false,
  isDeleteScheduleRequestLoading: false,
  taskFacilities: {
    taskColumnModal: { loading: false, taskId: null, facilities: [], error: null },
    updateSchedule: { loading: false, taskId: null, facilities: [], error: null },
    providerSchedule: { loading: false, taskId: null, facilities: [], error: null },
  },

  //Provider Metrics
  isProviderMetricsDropdownLoading: false,
  providerMetricsPriorityBucketDDList: [],
  providerMetricsPriorityDDList: [],
  providerMetricsModalityDDList: [],
  providerMetricsSubSpecialityDDList: [],
  providerMetricsWorkLocationDDList: [],

  //Rad Leadership Bulk Upload
  radLeadership: [],
  isRadLeadershipLoading: false,
  PracticeDirectorDetailsList: [],
  PracticeDirector: null,
  PracticeManagerDetailsList: [],
  PracticeManager: null,
  PhysicianLiaisonDetailsList: [],
  PhysicianLiaison: null,
  RadSectionChiefDetailsList: [],
  RadSectionChief: null,
  SectionChiefAssistantDetailsList: [],
  SectionChiefAssistant: null,
  QADirectorDetailsList: [],
  QADirector: null,
  isCheckingEditAccess: false,
  canEditRadLeadership: null,
  isDeletingUserSession: false,

  // Rad Hourly Volume Share states
  isRadHourlyVolumeShareLoading: false,
  radHourlyVolumeSharePendingRequests: 0,
  radHourlyVolumeShareUnreadDetails: [],
  radHourlyVolumeShareReadDetails: [],
  dropdownRadSites: [],
  worklistByRpceId: [],
  praticesByWorklistId: [],
  subPraticesByPraticeId: [],
  siteBySubPraticeId: [],
  isRadHourlyExportLoading: false,

  //AnnualHourTracker
  isAnnualHourTrackerLoading: false,
  annualHourTracker: {},
  annualHourTrackerDropdowns: {
    RadiologistDropdownItems: [],
    RadStatusDropdownItems: [],
    RadTypeDropdownItems: [],
    WeekRotationDropdownItems: [],
    RPCEDropdownItems: [],
    ScheduleTypeDropdownItems: [],
    SectionDropdownItems: [],
    SubSpecialityDropdownItems: [],
    DayDropdownItems: [],
    isrpceloading: false,
  },

  WorklistDropdownItems: [],
  TaskDropdownItems: [],

  // Custom View
  customViews: [],
  customViewFields: {},
  isCustomViewLoading: false,

  // Audit log load All Provider Dropdowns states
  isRadiologistAllDDListLoading: false,
  radiologistAllDDList: {},
  isModuleFieldActionTypeDropdownLoading: false,
  moduleFieldActionTypeDropdown: [],
  AuditDetails: [],
  isAuditDetailsLoading: false,
  iscustomAuditDetailsLoading: false,
  customAuditDetails: [],

  // Rate Card
  isRateCardLoading: false,
  rateCardDetails: [],

  // Rad Document Management
  radDocumentTypes: [],
  isRadDocTypesLoading: false,
  radDocuments: [],
  isRadDocumentsLoading: false,
  isUploadRadDocLoading: false,
  isDeleteRadDocLoading: false,
  isDownloadRadDocLoading: false,
  radDocumentFile: null,

  // Rad Notes
  isSaveRadNotesLoading: false,
  radNoteTypes: [],
  isFetchRadNoteTypesLoading: false,

  // Active Home State License Dropdown
  activeHomeStateLicenseDropdown: [],
  isActiveHomeStateLicenseDropdownLoading: false,
  activeHomeStateLicenseDropdownError: null,

  // Rad Tags
  isSaveRadTagsLoading: false,
  saveRadTagsError: null,

  // Rad Site Assignment Notes (shared across rad profile + site profile)
  radSiteAssignmentNotesList: [],
  isRadSiteAssignmentNotesLoading: false,
  allRadSiteAssignmentNotesList: [],
  isAllRadSiteAssignmentNotesLoading: false,
  isAddRadSiteAssignmentNoteLoading: false,
  addRadSiteAssignmentNoteSuccess: false,

  // License & Privileges Power Sync
  isLicensePrivilegesPowerSyncLoading: false,
  licensePrivilegePowerSync: {},
  licensePrivilegePowerSyncFilterOptions: {},
};

const initialExam = {
  isRawExamDataLoading: false,
  rawExamData: {},
  isExportingRawExamData: false,
  isUnreadExamDataLoading: false,
  unreadExamData: {},
  isTatDataLoading: false,
  tatData: {},

  // Miscellaneous Facility Data
  miscSiteData: [],
  isMiscSiteDataLoading: false,
  sitesDropdown: [],
  isSitesDropdownLoading: false,
  practiceSiteMapping: {},
  isPracticeSiteMappingLoading: false,
  isSavingMiscSites: false,
  saveResponse: null,
  saveError: null,

  isExamDataLoading: false,
  examData: {},
  // Cached exam data per tab
  examDataByTab: {},
  siteDDList: [],
  radDDList: [],
  priorityGroupDDList: [],
  priorityDDList: [],
  subspecialityDDList: [],
  recalculateData: {},
  examDataRecordDate: {},
  saveBatchRecordExamDataResponse: {},
  isSavingBatchRecordExamData: false,
  examDataBatch: {},
  isFetchingExamDataBatch: false,
  isSavingBatchRecord: false,
  saveBatchRecordResponse: {},
  isCheckingRecalculation: false,
  checkRecalculationData: {},
  isUnassignedCombinationsLoading: false,
  unassignedCombinations: [],
  isCheckingWorklistAssignments: false,
  checkWorklistAssignmentsData: {},
  checkedWorklistExamDataIds: [],
  checkedWorklistMappableCount: 0,
  isSavingWorklistMapping: false,
  saveWorklistMappingResponse: {},
  isSavingWorklistMappingUpdate: false,
  saveWorklistMappingUpdateResponse: {},
  unassignedExamDataCount: 0,
  isUnassignedExamDataCountLoading: false,
  isExportingCalculatedExamData: false,

  isExamMetricsDataLoading: false,
  examMetricsData: {},
  isExamMetricsDropdownLoading: false,
  isExamMetricsDateRangeLoading: false,
  examMetricsDropdownOptions: {},
  examMetricsDateRange: {},
  examMetricsDateRangeError: null,
  examMetricSites: [],
  examMetricSiteStatus: [],
  examMetricSiteCoverageType: [],
  examMetricPriorityBucket: [],
  examMetricPriority: [],
  examMetricModality: [],
  examMetricSubSpeciality: [],
  examMetricWorkList: [],
};

const initialSite = {
  siteCustomViews: [],
  isSiteCustomViewsLoading: false,
  siteCustomViewsError: null,
  isTogglingSiteCustomView: false,
  isDeletingSiteCustomView: false,
  isSiteCustomViewDataLoading: false,
  siteCustomViewData: null,
  siteCustomViewDataError: null,

  // Facility Hourly Volume Share states
  isSiteHourlyVolumeShareLoading: false,
  isSiteHourlyVolumeShareUnReadLoading: false,
  isSiteHourlyVolumeShareReadLoading: false,
  siteHourlyVolumeShareUnreadDetails: [],
  siteHourlyVolumeShareReadDetails: [],
  dropdownDetails: [],
  worklistByRpceId: [],
  praticesByWorklistId: [],
  subPraticesByPraticeId: [],
  isSiteHourlyExportLoading: false,

  // Facility List State Start
  siteListData: {
    values: [],
    recordsTotal: 0,
    recordsFiltered: 0,
  },
  isSiteListLoading: false,
  siteListError: null,
  isExporting: false,
  exportError: null,
  practiceDropdownData: [],
  isPracticeDropdownLoading: false,
  practiceDropdownError: null,
  siteDropdownData: {},
  isSiteDropdownLoading: false,
  siteDropdownError: null,
  subPracticeDropdownData: {},
  isSubPracticeDropdownLoading: false,
  subPracticeDropdownError: null,
  isSavingBulkPracticeSite: false,
  saveBulkPracticeSiteError: null,
  // Facility List State End

  //site profile state Start
  unassignedSiteListData: [],
  isUnassignedSiteListLoading: false,
  unassignedSiteListError: null,

  //site profile state starts here
  siteProfile: null,
  isSiteProfileLoading: false,
  siteCoverageHours: null,
  isSiteCoverageHoursLoading: false,
  siteAssociatedRads: null,
  isSiteAssociatedRadsLoading: false,
  siteAssociatedRadsError: null,
  siteCalendarDemand: null,
  siteWorklists: null,
  isSiteWorklistsLoading: false,
  siteWorklistsError: null,
  siteWorklistsRequest: null,
  siteCalendarDemandRequest: null,
  siteCalendarDemandByDateRequest: null,
  siteRadsDemandScheduleRequest: null,
  siteCalendarDemandError: null,
  siteCalendarDemandByDateError: null,
  siteRadsDemandScheduleError: null,
  isSiteCalendarDemandLoading: false,
  siteCalendarDemandByDate: null,
  isSiteCalendarDemandByDateLoading: false,
  siteRadsDemandSchedule: null,
  isSiteRadsDemandScheduleLoading: false,
  siteAssociatedRadMetrics: null,
  isSiteAssociatedRadMetricsLoading: false,
  siteAssociatedRadMetricsError: null,
  siteRadMetricsDropdown: null,
  isSiteRadMetricsDropdownLoading: false,
  siteRadMetricsDropdownError: null,
  siteMatrixChildTablesData: null,
  isSiteMatrixChildTablesLoading: false,
  siteProfileDemandByHoursChartData: null,
  isSiteProfileDemandByHoursChartLoading: false,
  siteProfileVolumeByPriorityChartData: null,
  isSiteProfileVolumeByPriorityChartLoading: false,
  siteProfileVolumeByModalityChartData: null,
  isSiteProfileVolumeByModalityChartLoading: false,
  siteProfileMetricsDropdown: null,
  isSiteProfileMetricsDropdownLoading: false,
  siteProfileDemandByHoursChartDetailsData: null,
  isSiteProfileDemandByHoursChartDetailsLoading: false,
  siteProfileVolumeByModalityChartDetailsData: null,
  isSiteProfileVolumeByModalityChartDetailsLoading: false,
  siteProfileVolumeByPriorityChartDetailsData: null,
  isSiteProfileVolumeByPriorityChartDetailsLoading: false,
  //site profile state End

  // Facility Alias Management state
  issitealiasmanagementLoading: false,
  sitealiasmanagementData: [],
  allsitesaliasData: {},
  issitealiasexporting: false,
  issitealiasstatuslaoding: false,
  issitealiasHistoryloading: false,
  sitealiasHistoryData: {},
  issitealiasmanagementbulksaveloading: false,

  // Edit Facility Profile state
  siteDetails: null,
  isSiteDetailsLoading: false,
  isSavingSiteDetails: false,
  isSaveSiteTagsLoading: false,
  siteDetailsError: null,
  saveSiteDetailsResponse: null,
  saveSiteTagsError: null,
  saveSiteDetailsError: null,
  sisterSiteHistory: null,
  isSisterSiteHistoryLoading: false,
  dropdownData: {},
  zipCodeData: {},
  zipCode: null,
  isUploadingModelInputFile: false,
  uploadModelInputResponse: null,
  uploadModelInputError: null,
  isSiteModelFilterLoading: false,
  siteModelFilterData: null,
  siteModelFilterError: null,
  isSavingSiteModelInput: false,
  saveSiteModelInputResponse: null,
  saveSiteModelInputError: null,
  isPrioritySubspecialitySplitLoading: false,
  prioritySubspecialitySplitData: null,
  prioritySubspecialitySplitError: null,
  isSavingPrioritySubspecialitySplit: false,
  savePrioritySubspecialitySplitResponse: null,
  savePrioritySubspecialitySplitError: null,
  isCheckingPrioritySubspecialityConfigBySiteId: false,
  prioritySubspecialityConfigBySiteIdData: null,
  prioritySubspecialityConfigBySiteIdError: null,
  siteOnboardingDetails: [],
  isExportingSiteAlias: false,
  isExportingSisterSites: false,
  //site profile state ends here

  // Rad Site Assignment Notes (shared across rad profile + site profile)
  radSiteAssignmentNotesList: [],
  isRadSiteAssignmentNotesLoading: false,
  allRadSiteAssignmentNotesList: [],
  isAllRadSiteAssignmentNotesLoading: false,
  isAddRadSiteAssignmentNoteLoading: false,
  addRadSiteAssignmentNoteSuccess: false,

  // Facility Custom View state
  isCustomViewLoading: false,
  customViewFields: {},
  isSavingFacilityCustomView: false,
  saveFacilityCustomViewSuccess: false,
  saveFacilityCustomViewError: null,
};

const initialReport = {
  // Report Configuration states
  isReportConfigurationLoading: false,
  reportConfigurationDetails: [],
  capacityTableReportDD: [],
  isCapacityDropdownLoading: false,
  selectedReportConfiguration: null,
  powerBIRefreshStatus: null,
};

const initialDailyReport = {
  powerBiLoading: false,
  powerBiError: null,
  embedConfig: null,
  lastRefreshedLoading: false,
  lastRefreshedDateTime: null,
  nextRefreshDateTime: null,
  lastRefreshedError: null,
};

const initialMarketVolumeShare = {
  powerBiLoading: false,
  powerBiError: null,
  embedConfig: null,
  lastRefreshedLoading: false,
  lastRefreshedDateTime: null,
  nextRefreshDateTime: null,
  lastRefreshedError: null,
};

const initialCoverageGapToolEncore = {
  powerBiLoading: false,
  powerBiError: null,
  embedConfig: null,
  lastRefreshedLoading: false,
  lastRefreshedDateTime: null,
  nextRefreshDateTime: null,
  lastRefreshedError: null,
  activeCapacityTableName: null,
};

const initialPerformanceDashboardCombined = {
  powerBiLoading: false,
  powerBiError: null,
  embedConfig: null,
  lastRefreshedLoading: false,
  lastRefreshedDateTime: null,
  nextRefreshDateTime: null,
  lastRefreshedError: null,
};

export const initialMatrixServiceRequestState = {
  strategicForecastData: [],
  isStrategicForecastLoading: false,
  isallsiteonboardingplannerloading: false,
  siteonboardingplannerdata: {},
  isRPCEloading: false,
  RPCEDATA: {},
  isworklistLoading: false,
  WORKLISTDATA: {},
  ismatrixserviceSaving: false,
  ismatrixservicedeleteLoading: false,
  isOnboardingSiteDemandPlannerLoading: false,
  OnboardingSiteDemandPlannerData: [],
  OnboardingSiteDemandPlannerLegendListData: [],
  // Strategic Caps vs Demand Planner
  isStrategicCapsLoading: false,
  isLoading: false,
  isDeleteStrategicCapsLoading: false,
  isStrategicCapsvsDemandData: [],
  filterDDList: [],
  isFilterLoading: false,
  reportsData: [],
  totalRecords: 0,
  notesEditData: "",
  selectedRPCEWorklist: [],
  notesSaveSuccess: false,
  deleteSuccess: false,
  dropdownData: [],
  wrvuSurplusWorklistData: [],
  wrvuSurplusWorklistTotalRecords: 0,
  wrvuSurplusData: [],
  wrvuSurplusTotalRecords: 0,
  fteSurplusData: [],
  fteSurplusTotalRecords: 0,
  legendData: [],
  // Action flags for draft/publish
  isStrategicCapsActionLoading: false,
  strategicCapsActionSuccess: false,
};
export const initialStrategicDemandState = {
  isStrategicDemandPlannerLoading: false,
  strategicDemandPlannerReports: [],
  totalReportsCount: 0,
  reportsTabError: null,

  isLoadingVolumeTrendReportsDD: false,
  volumeTrendReportsDD: [],
  volumeTrendReportsDDError: null,

  isDraftSaving: false,
  isPublishSaving: false,
  draftSuccess: false,
  publishSuccess: false,
  draftError: null,
  publishError: null,

  isBlockCapacityTableReportLoading: false,
  blockCapacityTableReportResponse: null,
  blockCapacityTableReportError: null,

  isDemandInputLoading: false,
  demandInputReports: [],
  demandInputTotalCount: 0,
  demandInputError: null,

  demandInputFilters: {
    lstRPCE: [],
    lstWorklist: [],
    lstPractice: [],
    lstDayType: [],
  },
  isDemandInputFilterDDLoading: false,
  demandInputFilterDDError: null,
  isWeekOrQuarterLoading: false,
  weekOrQuarterData: [],

  isWorklistLoading: false,
  RPCEDATA: [],
  siteOffboardingPlannerResponse: null,
  isSiteOffboardingLoading: false,
  isPracticeLoading: false,
  PRACTICEDATA: [],
  isSiteLegendLoading: false,
  siteLegend: null,
  siteLegendError: null,
  updateNoteSuccess: false,
  deleteSuccess: false,
  demandDailyData: [],
  demandDailyTotalCount: 0,
  isDemandDailyLoading: false,
  demandQuarterlyData: [],
  demandQuarterlyTotalCount: 0,
  isDemandQuarterlyLoading: false,
  demandQuarterlyError: null,
  capsDemandFilterById: {},
  isCapsDemandFilterByIdLoading: false,
  capsDemandFilterByIdError: null,
};
export const initialStrategicCapacity = {
  isLoadingBlockDemandPlanningReportsDD: false,
  blockDemandPlanningReportsDD: [],
  isExportCapacityReportLoading: false,
  exportCapacityReportError: null,
  isAllReportsLoading: false,
  allReportsData: [],
  allReportsTotalCount: 0,
  allReportsError: null,
  isBlockCapacityTableLoading: false,
  blockCapacityTableData: [],
  isCapacityTableReportLoading: false,
  capacityTableReportData: [],
  blockCapacityTableId: null,
  radData: {
    Active: [],
    Pending: [],
    Offboarding: [],
  },

  radLoading: {
    Active: false,
    Pending: false,
    Offboarding: false,
  },
  isRadTransitionsLoading: false,

  capacityDailyViewData: [],
  totalDailyRecords: 0,
  isCapacityDailyViewLoading: false,
  capacityDailyViewError: null,
  capacityFilterDD: {
    lstRPCE: [],
    lstWorklist: [],
    lstDay: [],
    lstDayType: [],
    lstCapacityType: [],
    lstWeekRotation: [],
    lstQuarter: [],
  },
  isCapacityFilterDDLoading: false,
  capacityFilterDDError: null,
  RPCEDATA: [],
  isWorklistLoading: false,
  capacityDailyLoaded: false,

  capacityQuarterlyViewData: [],
  totalQuarterlyRecords: 0,
  isCapacityQuarterlyViewLoading: false,
  capacityQuarterlyLoaded: false,
  // strategiccapacity cascading WeekQuarterByMonthYear
  weekRotationOptions: [],
  quarterOptions: [],
  isWeekQuarterLoading: false,
};

export const initialStrategicCapsVsDemandState = {
  capsDemandFilterById: [],
  capsDemandFilterByIdLoading: false,
  capsDemandFilterByIdError: null,
};

const initialDemandTable = {
  // Loading states
  isDemandTableLoading: false,
  isVolumeTrendLocked: false,

  // Main Dropdown data
  reportsDDList: [],
  selectedVolumeTrendReport: null,
  selectedDemandTableID: null, //dropdown Onchange

  // Reports Tab
  reportsTabData: [],
  notesEditData: {},
  notesSaveSuccess: false,

  // DemandInput Tab — real, already-filtered/grouped accumulated rows from
  // GetDemandTableById (TabNumber = 1); server does all filtering/aggregation.
  demandInputAccumulated: {
    Rows: [],
  },
  GetDemandInputFilterDDList: {
    practiceDDL: [],
    workListDDL: [],
    dayDDL: [],
  },
  // Demand Changes Facility sub-tab: Worklists mapped to the selected Facility/Site(s)
  worklistBySiteDDL: [],
  // Demand Changes Worklist sub-tab: worklists mapped to at least one facility (no
  // Facility field to cascade off of in this sub-tab, so not scoped to a specific site)
  worklistWithSiteMappingDDL: [],
  // Demand Table grid tab: Worklists mapped to the selected Worklist Group(s)
  worklistByGroupDDL: [],

  // Onboarding Tab
  onboardingTabData: [],

  // Offboarding Tab
  offboardingTabData: [],
  // Offboarding Tab
  termedTableData: [],
  offboardingTableData: [],

  // Demand Table Tab
  demandTableTabData: [],
  demandTableTotalRecords: 0,

  // Day Light Saving Tab
  dayLightSavingEndedData: [],
  dayLightSavingUpcomingData: [],

  // Demand Changes Tab
  demandChangesPracticeData: [],
  demandChangesSiteData: [],
  demandChangesWorklistData: [],
  holidayCoverageWorklistData: [],
  holidayCoveragePracticeData: [],
  holidayCoverageSiteData: [],
};

const initialVolumeTrendReport = {
  volumeTrendData: {},
  isLoadingVolumeTrend: false,
  pivotVolumeTrendData: {},
  isLoadingPivotVolumeTrend: false,
  unreadPivotVolumeTrendData: {},
  isLoadingUnreadPivotVolumeTrend: false,
  unreadPivotVolumeTrendBySiteData: {},
  isLoadingUnreadPivotVolumeTrendBySite: false,
  unreadPivotVolumeTrendBySitePriorityData: {},
  isLoadingUnreadPivotVolumeTrendBySitePriority: false,
  rolloverExamDataVolumeTrend: {},
  isLoadingRolloverExamDataVolumeTrend: false,
  isDeletingSchedulingForecastReport: false,
  volumeTrendReportsById: {},
  isLoadingVolumeTrendReportsById: false,
  schedulingForecastByIdData: {},
  isLoadingSchedulingForecastById: false,
  isSavingVolumeTrendReport: false,
  isLoadingDraftSavingVolumeTrendReport: false,
  draftSaveVolumeTrendReportResponse: {},
  isLoadingPublishingVolumeTrendReport: false,
  isLoadingExportingVolumeTrendReport: false,
  exportVolumeTrendReportResponse: {},
  isLoadingReportNote: false,
  reportNoteData: {},
  isLoadingSavingReportNote: false,
  saveReportNoteResponse: {},
  examDataVolumeTrend: {},
  isLoadingVolumeTrendDropDowns: false,
  volumeTrendDropDownsData: {},
  isLoadingVolumeTrendUnreadPivotPrioritySiteNonPaginated: false,
  volumeTrendUnreadPivotPrioritySiteNonPaginatedData: {},
  isLoadingVolumeTrendReportForecastSitePriorityNonPaginated: false,
  volumeTrendReportForecastSitePriorityNonPaginatedData: {},
};

const initialCapacityTable = {
  isCapacityTableLoading: false,
  capacityTableReports: [],
  selectedCapacityTable: null,
  notesEditData: null,
  isCapacityNotesEditLoading: false,
  notesEditFetchSuccess: null,
  notesSaveSuccess: false,
  exportSuccess: false,
  deleteSuccess: false,
  publishedReportsList: [],
  isPublishedReportsListLoading: false,
  shiftPasteInputList: [],
  isShiftPasteInputLoading: false,
  shiftPasteInputRecordsTotal: 0,

  // Provider Request (RadRequest) tab
  providerRequestList: [],
  isProviderRequestLoading: false,
  providerRequestRecordsTotal: 0,

  capacityTableReportData: null,
  isCapacityTableReportLoading: false,
  isCapacityTableDropdownsLoading: false,
  activeRadData: [],
  isActiveRadDataLoading: false,
  pendingRadData: [],
  isPendingRadDataLoading: false,
  offboardingRadData: [],
  isOffboardingRadDataLoading: false,
  saveIsExcludedResponse: null,
  isSaveIsExcludedLoading: false,
  unlinkScheduleResponse: null,
  isUnlinkScheduleLoading: false,
  relinkScheduleResponse: null,
  isRelinkScheduleLoading: false,
  deleteShiftInputDetailsResponse: null,
  isDeleteShiftInputDetailsLoading: false,
  shiftInputDetailsData: null,
  isGetShiftInputDetailsLoading: false,

  // Simulator RPCE Data
  simulatorRPCEData: [],
  isSimulatorRPCELoading: false,
  simulatorRPCERecordsTotal: 0,
  simulatorRPCERecordsFiltered: 0,
  error: null,

  // Capacity Table Grid Data
  capacityTableGridData: [],
  isCapacityTableGridLoading: false,
  capacityTableGridRecordsTotal: 0,
  capacityTableGridRecordsFiltered: 0,

  // Update Provider Shift Input Details
  updateShiftInputDetailsData: null,
  isUpdateShiftInputDetailsLoading: false,
  updateShiftInputDetailsError: null,

  // Draft Capacity Table Report
  isDraftCapacityTableReportLoading: false,
  draftCapacityTableReportSuccess: false,
  // Publish Capacity Table Report
  isPublishCapacityTableReportLoading: false,
  publishCapacityTableReportSuccess: false,
  // Shift Paste Input Duplicate Check
  isShiftPasteInputDuplicateCheckLoading: false,
  shiftPasteInputDuplicateCheckResponse: null,
  // UI flag to indicate new schedules were added via simulator modal
  simulatorNewSchedulesAdded: false,
  // Capacity RPCE Details (for Encore modal)
  capacityRPCEDetailsData: null,
  isCapacityRPCEDetailsLoading: false,

  capacityDetailsData: null,

  recordsTotal: 0,
  recordsFiltered: 0,

  // Simulator Refresh APIs
  isSimulatorRefreshLoading: false,
  simulatorRefreshError: null,
  emulatorWorklistData: null,

  isSimulatorRPCERefreshLoading: false,
  simulatorRPCERefreshError: null,
  emulatorRPCEData: null,

  // Capacity Table page - Demand Table tab (DemandTable/GetDemandTableDemandWithPagination)
  capacityDemandTableData: [],
  capacityDemandTableRecordsTotal: 0,
  isCapacityDemandTableLoading: false,
  capacityDemandTableFetchSuccess: null,

  // Capacity Table page - Demand Table tab filter panel (Worklist Group / Worklist / Day of Week)
  capacityDemandInputFilterDDList: { worklistGroupDDL: [], dayDDL: [] },
  isCapacityDemandInputFilterDDListLoading: false,
  capacityWorklistByGroupDDL: [],
  isCapacityWorklistByGroupDDLoading: false,
};

const initialCapsVsDemand = {
  capacityVsDemandData: [],
  isCapacityDDListLoading: false,

  ReportData: [],
  isReportLoading: false,

  isExportLoading: false,
  isShiftLoading: false,
  ShiftData: [],

  isFilterLoading: false,
  FilterDDList: {},

  // Worklist Group -> Worklist cascade lists/loading, keyed by tab
  // ("capVsDem" / "availableShifts") -- each tab keeps its own options list.
  isWorklistByGroupDDLoading: {},
  worklistByGroupDDL: {},

  isLegendLoading: false,
  LegendDDList: [],

  isShiftRPCELoading: false,
  RPCEData: [],

  isWorklistLoading: false,
  WorklistData: [],

  iscapsVsDemandRPCELoading: false,
  CapsVsDemandRPCEDATA: [],

  iscapsVsDemandWorklistLoading: false,
  CapsVsDemandWorklistData: [],

  isDeleteLoading: false,

  isCapacityDetailsLoading: false,
  CapacityDetailsData: [],

  isWorklistDetailsLoading: false,
  worklistDetailsData: [],

  isGetByIdDetailsLoading: false,
  getByIdDetailsData: [],

  isNotesLoading: false,
  notesDetailsData: [],

  isNotesSaveLoading: false,
  isPublishLoading: false,

  isCommonExportLoading: false,

  isGenerateReportLoading: false,
  GenerateReportData: null,

  isCapsVsDemandTabDetailsLoading: false,
  CapsVsDemandTabDetailsData: [],
  capsVsDemandTabDetailsTotalRecords: 0,

  isAvailableShiftsTabDetailsLoading: false,
  AvailableShiftsTabDetailsData: [],
  availableShiftsTabDetailsTotalRecords: 0,

  isAccessToDemandLoading: false,
  AccessToDemandData: [],
  accessToDemandTotalRecords: 0,
  accessToDemandWeekRotation: null,
};

const tenantManagement = {
  TenantManagement: [],
  isTenantManagementLoading: false,
  tenantDetails: {},
  isLoading: false,
  masterTenantTypes: [],
  savetenantDetails: false,
  saveSuccess: false,
  isLoadingsave: false,
  storageCategoryDropdown: [],
  masterCountryDropdowns: [],
  masterTimeZoneDropdowns: [],
  isLoadingActivateDeactivate: false,
  defaultTenantConfig: null,
  isLoadingDefaultTenantConfig: false,
  isSavingDefaultTenantConfig: false,
  saveDefaultTenantConfigSuccess: false,
};

const tenantHierarchyConfiguration = {
  masterHierarchy: [],
  tenantHierarchyConfiguration: {},
  isLoading: false,
  isSaving: false,
  isBulkSaving: false,
  isSaved: false,
  isAliasUpdated: false,
};

const timeZoneMaster = {
  masterTimeZone: {},
  isLoading: false,
  error: null,
};

const initialLiveAvailableShifts = {
  isLiveAvailableShiftsLoading: false,
  isLegendLoading: false,
  isPriorityGroupingLegendLoading: false,
  isRadRequestTypeLoading: false,
  isSaveRadRequestLoading: false,
  isRecurrenceLoading: false,

  liveAvailableShiftsData: [],
  liveAvailableShiftsDataTotal: 0,
  isModalScheduleLoading: false,
  modalScheduleData: [],
  modalScheduleDataTotal: 0,
  LegendDDList: [],
  priorityGroupingLegendList: [],
  radRequestTypeOptions: [],
  recurrenceOptions: [],
  ID: null,
  LastRefreshedInfo: "",
  datemodel: [],
  isLiveAvailableShiftsFiltersLoading: false,
  isLiveAvailableShiftsWorklistLoading: false,
  liveAvailableShiftsFilters: {},
  liveAvailableShiftsWorklists: [],
  isSaveLiveAvailableShiftsFiltersLoading: false,
};

const initialForecast = {
  isForecastLoading: false,
  reportsTabData: [],
  notesEditData: {},
  notesSaveSuccess: false,
  isLoadingWorklistDropdown: false,
  isLoadingDemandData: false,
  demandDropdowns: {},
  isMounted: {
    practice: false,
    site: false,
  },
  practiceDemandData: [],
  siteDemandData: [],
  saveForecastingDemandSuccess: false,
  lstPractices: [],
  lstSites: [],
  lstPriorities: [],
  lstForecastRange: [],
  isLoadingVisualsData: false,
  visualsData: {},
};

const today = new Date();
const toDateKey = (value) => {
  const date = new Date(value);
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const day = `${date.getDate()}`.padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const todayKey = toDateKey(today);
const firstOfMonth = toDateKey(new Date(today.getFullYear(), today.getMonth(), 1));
const endOfMonth = toDateKey(new Date(today.getFullYear(), today.getMonth() + 1, 0));

export const initialSchedulingCalendar = {
  loading: false,
  error: null,
  view: "month",
  searchTerm: "",
  range: {
    fromDate: firstOfMonth,
    toDate: endOfMonth,
    anchorDate: todayKey,
  },
  rawSchedules: [],
  cacheByRangeKey: {},
  lastRequestCacheKey: "",
  metadata: {
    loading: false,
    tasks: [],
    radiologists: [],
  },
  listState: {
    page: 1,
    perPage: 25,
    sortField: "date",
    sortDirection: "asc",
  },
  shiftMutation: {
    saving: false,
    deleting: false,
    error: null,
  },
  adhocDropdowns: {
    loading: false,
    taskTags: [],
    providerTags: [],
    tasks: [],
    providers: [],
    facilityTags: [],
    facilities: [],
    taskLocations: [],
    worklists: [],
    recurrences: [],
    error: null,
  },
  taskFacilities: {
    addShift: { loading: false, taskId: null, facilities: [], error: null },
    assignProviders: { loading: false, taskId: null, facilities: [], error: null },
    editShift: { loading: false, taskId: null, facilities: [], error: null },
    shiftDetails: { loading: false, taskId: null, facilities: [], error: null },
  },
  filters: {
    isFilterPanelOpen: false,
    selectedWorklists: [],
    selectedTaskTags: [],
    selectedTasks: [],
    selectedFacilityTags: [],
    selectedFacilities: [],
    selectedProviderTags: [],
    selectedProviders: [],
    selectedTaskLocations: [],
    selectedScheduleStatus: null,
    fromDate: "",
    toDate: "",
  },
  adhocCheck: {
    loading: false,
    data: null,
    error: null,
  },
  adhocSave: {
    saving: false,
    data: null,
    error: null,
  },
  generateSchedules: {
    loading: false,
    data: null,
    error: null,
  },
  shareLinkCreate: {
    loading: false,
    data: null,
    error: null,
  },
  shareLinkEmail: {
    sending: false,
    data: null,
    error: null,
  },
  shareLinkList: {
    loading: false,
    data: [],
    error: null,
  },
  shareLinkEmailAudit: {
    loading: false,
    data: [],
    error: null,
  },
  shareLinkDeleteMutation: {
    deleting: false,
    error: null,
  },
  shareLinkDateRangeUpdate: {
    saving: false,
    error: null,
  },
};

export const initialProviderRequest = {
  list: [],
  loading: false,
  recordsTotal: 0,
  error: null,

  dropdowns: {
    loading: false,
    providers: [],
    requestTypes: [],
    tasks: [],
    taskLocations: [],
    statuses: [],
    recurrences: [],
    providerTypes: [],
    error: null,
  },

  filters: {
    isFilterPanelOpen: false,
    fromDate: "",
    toDate: "",
    selectedProviders: [],
    selectedRequestTypes: [],
    selectedTasks: [],
    selectedStatuses: [],
    showNewShift: true,
    showTimeOff: true,
  },

  statusMutation: {
    updating: false,
    error: null,
  },
  bulkTaskMutation: {
    saving: false,
    error: null,
  },

  adhocCheck: {
    loading: false,
    data: null,
    error: null,
  },
  adhocSave: {
    saving: false,
    data: null,
    error: null,
  },
  scheduleRequestTransaction: {
    loading: false,
    saving: false,
    data: null,
    error: null,
  },
};

// const initialForecastingForecast = {
//   isForecastingForecastLoading: false,
//   forecastingForecastData: [],
// };

const initialState = {
  auth: initialAuth,
  admin: initialAdmin,
  common: initialCommon,
  dropdownMgmt: initialDropdownMgmt,
  configuration: initialConfiguration,
  rad: initialRad,
  exam: initialExam,
  site: initialSite,
  report: initialReport,
  dailyReport: initialDailyReport,
  marketVolumeShare: initialMarketVolumeShare,
  coverageGapToolEncore: initialCoverageGapToolEncore,
  performanceDashboardCombined: initialPerformanceDashboardCombined,
  matrixServiceRequest: initialMatrixServiceRequestState,
  demandTableReducer: initialDemandTable,
  VolumeTrendReportReducer: initialVolumeTrendReport,
  strategicdemandReducer: initialStrategicDemandState,
  strategicCapacityReducer: initialStrategicCapacity,
  strategicCapsVsDemandReducer: initialStrategicCapsVsDemandState,
  capacityTableReducer: initialCapacityTable,
  CapsVsDemandReducer: initialCapsVsDemand,
  tenantManagementReducer: tenantManagement,
  tenantHierarchyConfigurationReducer: tenantHierarchyConfiguration,
  timeZoneMasterReducer: timeZoneMaster,
  liveAvailableShiftsReducer: initialLiveAvailableShifts,
  forecastReducer: initialForecast,
  schedulingCalendar: initialSchedulingCalendar,
  providerRequest: initialProviderRequest,
  // forecastingForecastReducer: initialForecastingForecast,
};

export default initialState;
